import { combineReducers } from 'redux';

import simpleSearchReducer from 'modules/global/reducers/simpleSearchReducer';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';

/**
 * @typedef {{
 *  data: Record<string, { id: string, name: string, phoneNumber: string, status: string }>,
 *  search: import("modules/global/reducers/simpleSearchReducer").SimpleSearchReducer,
 * }} DealerConfigurationIntegrationsWhatsAppAccountReducer
 */

export default combineReducers({
  data: createReducer({}, {
    [types.FETCH_WHATSAPP_ACCOUNTS_SUCCESS]: (state, { payload }) => payload.content.reduce(
      (acc, whatsAppAccount) => ({
        ...acc,
        [whatsAppAccount.id]: whatsAppAccount }),
      state
    )
  }),
  search: simpleSearchReducer(types.FETCH_WHATSAPP_ACCOUNTS_REQUEST),
});
